import React, { useContext } from "react";

// To push history
import { useHistory } from "react-router-dom";

//components
import HomeIconContent from "./HomeIconContent";

// Global state
import { StateContext, StateDispatchContext } from "../../AppStateContext";

const HomeIcon = ({ moduleName }) => {
  // Consuming state
  const state = useContext(StateContext);
  const setState = useContext(StateDispatchContext);

  const history = useHistory();

  const handleClick = () => {
    setState({
      ...state,
      currentModule: moduleName,
    });

    localStorage.setItem("currentModule", JSON.stringify(moduleName));

    history.push(`/console/${moduleName.replace(" ", "-")}`);
  };

  if (!state.ignoreModules.includes(moduleName)) {
    return (
      <HomeIconContent handleClick={handleClick} moduleName={moduleName} />
    );
  } else {
    return null;
  }
};

export default HomeIcon;
